import type React from 'react';

import type { EventMatchingDescriptorDescriptorType } from '@vlabs/api/luna-api/model/EventMatchingDescriptorDescriptorType';
import { FaceSample, BodySample, FacePlusBodySample } from '@vlabs/uikit';

import st from './EventCardSample.module.sass';

interface EventCardSampleProps {
  matcherType: EventMatchingDescriptorDescriptorType;
  sampleFaceSrc?: string;
  sampleBodySrc?: string;
}

export function EventCardSample({
  matcherType,
  sampleFaceSrc = undefined,
  sampleBodySrc = undefined,
}: EventCardSampleProps): React.JSX.Element {
  if (sampleFaceSrc && !sampleBodySrc) {
    return (
      <FaceSample
        className={st.Sample}
        src={sampleFaceSrc}
      />
    );
  }

  if (!sampleFaceSrc && sampleBodySrc) {
    return (
      <BodySample
        className={st.Sample}
        src={sampleBodySrc}
      />
    );
  }

  if (sampleFaceSrc && sampleBodySrc) {
    return (
      <FacePlusBodySample
        bodySampleProps={{ className: st.Sample, src: sampleBodySrc }}
        defaultMainImage={matcherType}
        faceSampleProps={{ className: st.Sample, src: sampleFaceSrc }}
      />
    );
  }

  return (<FaceSample className={st.Sample} />);
}
